export enum BodyPartGroupType {
    TORSO_NECK = "TORSO_NECK",
    ARMS = "ARMS",
    LEGS = "LEGS"
}
